var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._b({attrs:{"auto-grow":_vm.autoGrow,"counter":_vm.counter,"filled":_vm.filled,"label":_vm.label,"outlined":_vm.outlined,"readonly":_vm.readonly,"rounded":_vm.rounded,"rules":_vm.rules},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-textarea',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }